import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-md" }
const _hoisted_2 = { class: "flex items-center space-x-4" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "text-left text-xs" }
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "text-left text-xs" }
const _hoisted_7 = ["id"]
const _hoisted_8 = { class: "text-left text-xs" }
const _hoisted_9 = ["id"]
const _hoisted_10 = { class: "text-left text-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_dx_tooltip = _resolveComponent("dx-tooltip")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parkingSpotCount, (count) => {
    return (_openBlock(), _createElementBlock("div", {
      key: count.name,
      class: _normalizeClass(`flex  w-full items-center justify-between space-y-1 border border-gray-300 p-4 shadow-sm`)
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("h2", {
          class: _normalizeClass(`text-3xl font-bold ${count.color}`)
        }, _toDisplayString(count.count), 3),
        _createElementVNode("h4", _hoisted_1, _toDisplayString(_ctx.$t(count.name)), 1)
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.checkIfSpaceContainsType(count, 1))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: _ctx.sanitizeId(count.name, 'regular'),
              class: "text-center"
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'car'],
                class: "text-gray-400"
              }),
              _createElementVNode("p", {
                class: _normalizeClass(count.color)
              }, _toDisplayString(_ctx.checkIfSpaceContainsType(count, 1)?.count), 3),
              _createVNode(_component_dx_tooltip, {
                target: `#${_ctx.sanitizeId(count.name, 'regular')}`,
                "show-event": "mouseenter",
                "hide-event": "mouseleave"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("Dashboard.Tooltip.Regular")), 1)
                ]),
                _: 1
              }, 8, ["target"])
            ], 8, _hoisted_3))
          : _createCommentVNode("", true),
        (_ctx.checkIfSpaceContainsType(count, 2))
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              id: _ctx.sanitizeId(count.name, 'handicapped'),
              class: "text-center"
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'wheelchair'],
                class: "text-gray-400"
              }),
              _createElementVNode("p", {
                class: _normalizeClass(count.color)
              }, _toDisplayString(_ctx.checkIfSpaceContainsType(count, 2)?.count), 3),
              _createVNode(_component_dx_tooltip, {
                target: `#${_ctx.sanitizeId(count.name, 'handicapped')}`,
                "show-event": "mouseenter",
                "hide-event": "mouseleave"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("Dashboard.Tooltip.Handicapped")), 1)
                ]),
                _: 1
              }, 8, ["target"])
            ], 8, _hoisted_5))
          : _createCommentVNode("", true),
        (_ctx.checkIfSpaceContainsType(count, 3))
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              id: _ctx.sanitizeId(count.name, 'charging'),
              class: "text-center"
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'charging-station'],
                class: "text-gray-400"
              }),
              _createElementVNode("p", {
                class: _normalizeClass(count.color)
              }, _toDisplayString(_ctx.checkIfSpaceContainsType(count, 3)?.count), 3),
              _createVNode(_component_dx_tooltip, {
                target: `#${_ctx.sanitizeId(count.name, 'charging')}`,
                "show-event": "mouseenter",
                "hide-event": "mouseleave"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("Dashboard.Tooltip.Charging")), 1)
                ]),
                _: 1
              }, 8, ["target"])
            ], 8, _hoisted_7))
          : _createCommentVNode("", true),
        (_ctx.checkIfSpaceContainsType(count, 4))
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              id: _ctx.sanitizeId(count.name, 'reserved'),
              class: "text-center"
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'registered'],
                class: "text-gray-400"
              }),
              _createElementVNode("p", {
                class: _normalizeClass(count.color)
              }, _toDisplayString(_ctx.checkIfSpaceContainsType(count, 4)?.count), 3),
              _createVNode(_component_dx_tooltip, {
                target: `#${_ctx.sanitizeId(count.name, 'reserved')}`,
                "show-event": "mouseenter",
                "hide-event": "mouseleave"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("Dashboard.Tooltip.Reserved")), 1)
                ]),
                _: 1
              }, 8, ["target"])
            ], 8, _hoisted_9))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(`${count.bgColor} flex h-14 w-14 items-center justify-center rounded-full`)
      }, [
        _createVNode(_component_font_awesome_icon, {
          class: _normalizeClass(`${count.color} text-xl`),
          icon: count.icon
        }, null, 8, ["class", "icon"])
      ], 2)
    ]))
  }), 128))
}